import React from "react"
import RootLayout from "./RootLayout"
export const wrapRootElement = ({ element }) => (
  <RootLayout>{element}</RootLayout>
)
